import styled, { css } from 'styled-components'
import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Spacings, Text, Devices } from '@styles'

export const FormBody = styled(DrawerBodyWrapper)``

export const FormFooter = styled(DrawerFooterWrapper)`
	gap: ${Spacings.SPACING_3B};
`

export const FormSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
	margin-bottom: ${Spacings.SPACING_3B};
`

export const SectionLabel = styled.label`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};

	& > span {
		color: ${({ theme }) => theme.palette.background.red};
		margin-left: ${Spacings.SPACING_1};
	}
`

export const DateTimeRow = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_3B};
	align-items: flex-start;
`

export const DateField = styled.div`
	flex: 2;
`

export const TimeField = styled.div`
	flex: 1;
`

export const MeetingTypeRow = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_3B};
	flex-wrap: wrap;
`

export const MeetingTypeOption = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: ${Spacings.SPACING_1B};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	border-radius: ${Spacings.SPACING_2B};
	border: 1.5px solid ${({ theme, $active }) => ($active ? theme.palette.background.blue : theme.palette.background.border)};
	background: ${({ theme, $active }) => ($active ? theme.palette.background.bluelightest2 : theme.palette.background.white)};
	color: ${({ theme, $active }) => ($active ? theme.palette.text.blue : theme.palette.text.black)};
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ $disabled, $active }) => ($disabled && !$active ? 0.5 : 1)};
	pointer-events: ${({ $disabled, $active }) => ($disabled && !$active ? 'none' : 'auto')};
	transition: all 0.15s ease-in;
	min-width: 6rem;

	& > svg {
		font-size: ${Text.X_LARGE};
	}

	& > span {
		font-size: ${Text.SMALL};
		font-weight: ${Text.BOLD_500};
		white-space: nowrap;
	}

	&:hover {
		border-color: ${({ theme }) => theme.palette.background.blue};
		color: ${({ theme }) => theme.palette.text.blue};
	}
`

export const PhoneInputRow = styled.div`
	display: flex;
`

export const CountryCodeField = styled.div`
	margin-right: ${Spacings.SPACING_2B};
	max-width: 4rem;
	flex-shrink: 0;
`

export const PhoneNumberField = styled.div`
	flex-grow: 1;
`

export const GuestInputRow = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	align-items: center;

	& > div:first-child {
		flex: 1;
	}
`

export const AddUserButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 ${Spacings.SPACING_3B};
	min-height: 2.5rem;
	margin-top: 0.5rem;
	border-radius: ${Spacings.SPACING_2B};
	border: 1px solid ${({ theme }) => theme.palette.background.blue};
	background: ${({ theme }) => theme.palette.background.white};
	color: ${({ theme }) => theme.palette.text.blue};
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	cursor: pointer;
	white-space: nowrap;
	transition: all 0.15s ease-in;

	&:hover {
		background: ${({ theme }) => theme.palette.background.bluelightest2};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const GuestChipList = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	margin-top: ${Spacings.SPACING_1B};
	overflow-x: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
`

export const GuestChip = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_10};
	background: ${({ theme }) => theme.palette.background.searchgrey};
	color: ${({ theme }) => theme.palette.text.primary};
	font-size: ${Text.SMALL};

	& > svg {
		font-size: ${Text.MEDIUM};
		cursor: pointer;
		color: ${({ theme }) => theme.palette.text.label};
		transition: color 0.15s ease-in;

		&:hover {
			color: ${({ theme }) => theme.palette.text.red};
		}
	}
`
